import * as React from "react";
import Select, { components } from "react-select";

interface CustomSelectInputProps {
  options: any[];
  value: any[];
  onChange: (data: any[]) => void;
  placeholder: string;
  searchPlaceholder?: string;
}

const CustomMultiValue = () => null;

const CustomValueContainer = ({ children, ...props }: any) => {
  const { selectProps } = props;
  const isMenuOpen = selectProps?.menuIsOpen;

  const handleMouseDown = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (
      selectProps &&
      selectProps.menuIsOpen !== undefined &&
      selectProps.setMenuIsOpen
    ) {
      selectProps.setMenuIsOpen(true);
    } else {
      props.select.select.openMenu("first");
    }
  };

  // If menu is open, render the default children (which includes the search input)
  if (isMenuOpen) {
    return (
      <components.ValueContainer {...props}>
        {children[1]}
      </components.ValueContainer>
    );
  }

  // If menu is closed, show the custom placeholder
  return (
    <components.ValueContainer {...props}>
      <div onMouseDown={handleMouseDown} style={{ width: "100%" }}>
        <div className="dropdown__placeholder">{selectProps.placeholder}</div>
      </div>
    </components.ValueContainer>
  );
};

export default function CustomSelectInput(props: CustomSelectInputProps) {
  return (
    <Select
      className={`multi-select ${props.value.length > 0 ? "rmsc2" : ""}`}
      options={props.options}
      value={props.value}
      onChange={(data) => {
        props.onChange([...data]);
      }}
      isMulti
      placeholder={props.placeholder}
      isClearable={false}
      isSearchable
      classNamePrefix="dropdown"
      hideSelectedOptions={false}
      components={{
        MultiValue: CustomMultiValue,
        ValueContainer: CustomValueContainer,
        Input: (inputProps) => (
          <components.Input
            {...inputProps}
            style={{
              color: "inherit",
              background: "transparent 0px center",
              gridArea: "1 / 2",
              font: "inherit",
              minWidth: "2px",
              border: "none",
              margin: "0px",
              outline: "none",
              padding: "0px",
            }}
            placeholder={props.searchPlaceholder || "Search..."}
          />
        ),
      }}
    />
  );
}
